import vue from 'vue'
import loadingComponent from './Loading.vue'

const LoadingConstructor = vue.extend(loadingComponent)

let toastDom, el;

function showLoading() {
	if (!el && !toastDom) {
		el = document.createElement('div');
		toastDom = new LoadingConstructor({
			el,
			data() {
				return {
					isShow: true, // 是否显示
					// title // 文本内容
				};
			}
		});
		// 添加节点
		document.body.appendChild(toastDom.$el);
	} else {
		toastDom.isShow = true;
	}
}

function hideLoading() {
	if (toastDom) {
		toastDom.isShow = false;
	}
}

// 全局注册
function registryToast() {
	vue.prototype.$showLoading = showLoading;
	vue.prototype.$hideLoading = hideLoading;
}

export default registryToast;
